import { Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import { useDevice } from '../hooks/device'
import { useMapControls } from '../contexts/MapControlsContext'

const ManualModeInstructions = () => {
  const { t } = useTranslation()
  const device = useDevice()
  const { dragging } = useMapControls()
  const isMobile = device?.platformType === 'mobile'

  const desktopMesssage = dragging
    ? t('map.manualModeInstructions.desktopDragging')
    : t('map.manualModeInstructions.desktopNotDragging')

  const message = isMobile ? t('map.manualModeInstructions.mobile') : desktopMesssage

  return (
    <div
      className="absolute p-3 left-[50%] z-[10] top-16 -translate-x-1/2"
      data-testid="manual-mode-instructions"
    >
      <div className="rounded-lg shadow py-2 px-4 bg-accent-500/70">
        <Typography variant={isMobile ? 'small' : 'paragraph'} className="font-bold text-primary">
          {message}
        </Typography>
      </div>
    </div>
  )
}

export default ManualModeInstructions
